// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"O9-z"};